module.exports = __webpack_public_path__ + "img/bailey-logo-primary.5db90fe5.png";